module.exports = __webpack_public_path__ + "static/media/icon-app.4974f6e7.svg";